import { type AxiosRequestConfig, type AxiosResponse } from "axios";
import { getCachedAppConfiguration } from "appConfig";
import { axiosFetch } from "./axiosHelpers";

async function getApiUrl(relativeUrl: string): Promise<string> {
  const appConfiguration = await getCachedAppConfiguration();
  return `${appConfiguration.apiUrl}${relativeUrl}`;
}

async function get<T, H>(requestUrl: string, props?: T, headers?: H) {
  const finalUrl = await getApiUrl(requestUrl);
  return axiosFetch.get(finalUrl, props, headers);
}

async function safeGet<T, H, R>(
  requestUrl: string,
  props?: T,
  headers?: H
): Promise<R> {
  const finalUrl = await getApiUrl(requestUrl);
  return axiosFetch.safeGet<T, H, R>(finalUrl, props, headers);
}

async function post<T, H, C>(
  requestUrl: string,
  body?: T,
  headers?: H,
  config?: C
) {
  const finalUrl = await getApiUrl(requestUrl);
  return axiosFetch.post<T, H, C>(finalUrl, body, headers, config);
}

async function safePost<T, H, C, R>(
  requestUrl: string,
  body?: T,
  headers?: H,
  config?: C,
  customize?: (requestConfig: AxiosRequestConfig<T>) => AxiosRequestConfig<T>
): Promise<AxiosResponse<R>> {
  const finalUrl = await getApiUrl(requestUrl);
  return axiosFetch.safePost<T, H, C, R>(
    finalUrl,
    body,
    headers,
    config,
    customize
  );
}

async function put<T, H, C>(
  requestUrl: string,
  body?: T,
  headers?: H,
  config?: C
) {
  const finalUrl = await getApiUrl(requestUrl);
  return axiosFetch.put<T, H, C>(finalUrl, body, headers, config);
}

async function safePut<T, H, C, R>(
  requestUrl: string,
  body?: T,
  headers?: H,
  config?: C
): Promise<AxiosResponse<R>> {
  const finalUrl = await getApiUrl(requestUrl);
  return axiosFetch.safePut<T, H, C, R>(finalUrl, body, headers, config);
}

async function patch<T, H, C>(
  requestUrl: string,
  body?: T,
  headers?: H,
  config?: C
) {
  const finalUrl = await getApiUrl(requestUrl);
  return axiosFetch.patch<T, H, C>(finalUrl, body, headers, config);
}

async function del<H, C>(requestUrl: string, headers?: H, config?: C) {
  const finalUrl = await getApiUrl(requestUrl);
  return axiosFetch.del<H, C>(finalUrl, headers, config);
}

export const axiosEjFetch = {
  get,
  post,
  put,
  patch,
  del,
  safeGet,
  safePost,
  safePut,
};
